import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';
import { UserPlus, Download } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ManageInscriptions() {
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/forum/registrations`, { headers });
        setItems(res.data);
      } catch (e) { toast.error('Erreur'); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  return (
    <div data-testid="manage-inscriptions">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1E3A5F]">Inscriptions au Forum</h1>
        <p className="text-sm text-[#6B7C93]">{items.length} inscription(s)</p>
      </div>

      <Card className="border-0 shadow-sm">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nom</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Entreprise</TableHead>
                <TableHead>Fonction</TableHead>
                <TableHead>Téléphone</TableHead>
                <TableHead>Date</TableHead>
                <TableHead className="w-16">Badge</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className="font-medium">{item.full_name}</TableCell>
                  <TableCell className="text-sm text-[#6B7C93]">{item.email}</TableCell>
                  <TableCell className="text-sm">{item.company}</TableCell>
                  <TableCell className="text-sm">{item.job_title}</TableCell>
                  <TableCell className="text-sm">{item.phone}</TableCell>
                  <TableCell className="text-sm text-[#6B7C93]">{new Date(item.created_at).toLocaleDateString('fr-FR')}</TableCell>
                  <TableCell>
                    <a href={`${API}/badge/${item.id}`} target="_blank" rel="noopener noreferrer" className="text-[#1E3A5F] hover:text-[#F5A623]" data-testid={`badge-${item.id}`}>
                      <Download className="w-4 h-4" />
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {!loading && items.length === 0 && (
            <div className="text-center py-12 text-[#6B7C93]"><UserPlus className="w-12 h-12 mx-auto mb-3 opacity-30" /><p>Aucune inscription</p></div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
